import { render, staticRenderFns } from "./QuotationTemplatePage.vue?vue&type=template&id=770d7582"
import script from "./QuotationTemplatePage.vue?vue&type=script&lang=js"
export * from "./QuotationTemplatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports